export const BASE_URL = "/";

export const routesURLS = {
    CONTACT: `${BASE_URL}contact`,
    ABOUT: `${BASE_URL}about`,
    BLOGS: `${BASE_URL}blogs`,
    HOME : `${BASE_URL}`,
    JOBS: `${BASE_URL}jobs`,
    LIFEAT: `${BASE_URL}lifeatloopnix`
};